import { ResumeCustom } from "lib/redux/types";
import React from "react";
import { TemplateSevenResumeSection } from "./common";
import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "../ResumePDF/common";
import { styles } from "../ResumePDF/styles";

const Custom = ({
  heading,
  custom,
  themeColor,
  showBulletPoints,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  showBulletPoints: boolean;
}) => {
  const { descriptions } = custom;
  return (
    <TemplateSevenResumeSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription items={descriptions} />
      </View>
    </TemplateSevenResumeSection>
  );
};

export default Custom;
